import React, { useCallback } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { InputGroup, SInput } from '../input-group'
import { EyeIcon } from '../icons/eye-icon'
import { isSupportDomain } from '../currentDomain'

export const SShowPasswordToggle = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    border: none;
    outline: 0;
    background-color: transparent;
    text-transform: uppercase;
    font-size: 11px;
`

export type PasswordInputProps = {
    showPassword: boolean
    onChange: (value: string) => void
    label?: string
    placeholder: string
    name?: string
    autoComplete?: React.InputHTMLAttributes<HTMLInputElement>['autoComplete']
    toggleShowPasswordFlag: (flag: boolean) => void
    hasText?: boolean
    message?: string | React.ReactElement | null
    error?: string | React.ReactElement | null
    errorTestId?: string
    className?: ClassName
    style?: React.CSSProperties
}

export function PasswordInput({
    showPassword,
    onChange,
    label,
    placeholder,
    name,
    autoComplete,
    toggleShowPasswordFlag,
    hasText = false,
    message,
    error,
    errorTestId,
    className,
    style,
}: PasswordInputProps): React.ReactElement {
    const handleMouseDown = useCallback(() => {
        toggleShowPasswordFlag(true)
        document.addEventListener(
            'mouseup',
            () => {
                toggleShowPasswordFlag(false)
            },
            { once: true }
        )
        document.addEventListener(
            'touchend',
            () => {
                toggleShowPasswordFlag(false)
            },
            { once: true }
        )
    }, [])

    return (
        <div className={cn(className)} style={style}>
            <InputGroup
                label={label}
                message={message}
                errorMsg={error}
                inverted={isSupportDomain}
                errorTestId={errorTestId}
            >
                <SInput
                    name={name}
                    autoComplete={autoComplete}
                    type={showPassword ? 'text' : 'password'}
                    password={true}
                    placeholder={placeholder}
                    onChange={(event) => onChange(event.currentTarget.value)}
                    hasText={hasText}
                    inverted={isSupportDomain}
                    data-testid={'passwordInput'}
                />
                <SShowPasswordToggle
                    tabIndex={-1}
                    type="button"
                    onMouseDown={() => handleMouseDown()}
                    onTouchStart={() => handleMouseDown()}
                    data-testid="eyeIconBtn"
                >
                    <EyeIcon color={isSupportDomain ? '#fff' : '#535353'} />
                </SShowPasswordToggle>
            </InputGroup>
        </div>
    )
}
